import React from 'react';
import PropTypes from 'prop-types';
import { default as WmsButton } from '../../components/WmsButton/WmsButton.jsx';
import { default as WmsInput } from '../../components/WmsInput/WmsInput.jsx';
import { default as WmsCheckBox } from '../../components/WmsCheckBox/WmsCheckBox.jsx';
import { default as WmsButtonDropdown } from '../../components/WmsButtonDropdown/WmsButtonDropdown.jsx';
import { default as WmsMenuItem } from '../../components/WmsMenuItem/WmsMenuItem.jsx';
import { default as WmsContextMenu } from '../../components/WmsContextMenu/WmsContextMenu.jsx';
import { default as WmsRadio } from '../../components/WmsRadio/WmsRadio.tsx';

import * as GlobalService from '../../global_services';
import { ObjectWms } from '../../../../assets/ts/ObjectWms.ts';

import { KendoGridWmsVirtual } from '../../../../assets/ts/KendoGridWmsVirtual.ts';
import { resolveArrowBaseRow, getNextArrowNavRow, indexOfViewRow, indexOfViewRowByKey, viewIndexRangeForKeys, sliceViewByIndexRange, isEditableKeyboardTarget, arrowKeyDirection, isHorizontalArrowKey } from '../../../../assets/ts/ArrowNavSelectionWms.ts';
import style from "./VirtualGridComponent.scss";

const withVisibleRowNumberHeader = (columns) => columns.map((column) => (
    column.field === "RowNumber"
        ? {
            ...column,
            title: column.rowNumberHeaderTitle || "#",
            headerTemplate: "",
            headerAttributes: {
                ...column.headerAttributes,
                class: `${column.headerAttributes?.class || ""} wms-row-number-header-cell`.trim(),
                "data-row-number-title": column.rowNumberHeaderTitle || "#"
            }
        }
        : column
));

class VirtualGridComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        this.isUpdatingTemplate = false; // Flag to prevent infinite loop
        this.lastTemplateKey = null; // Track last template to avoid unnecessary updates
        this.state = {
            gridDomSelector: () => this.props.windowId ? '.' + this.props.windowId + ' #' + this.props.id : '#' + this.props.id,
            sortArrayGrid: [], // default set of sorts on the grid
            dataBindingInitial: 0,
            intialiseKeyDown: 0,
            totalResult: 0,
            filterResult: 0,
            sortColums: '',
            layoutData: this.props.layoutData,
            disabledText: "",
            selectedOrders: 0,
            scanGridKey: "",
            selectAll: false,
            isCombineRows: false,
            isHovering: false,
            KendoGrid: new KendoGridWmsVirtual(this.props.id, this.props.windowId, this.props.gridKeySelection, this.props.getGridSelectionUrl),
            staticGridData: props.staticGridData ? props.staticGridData : [],
            filterObject: props.filterObject,
            transportData: {},
            gridExpandIndex: null,
            scrollPos: 0,
            columns: props.defaultColumns,
            schema: props.schema,
            sorts: [],
            filter: [],
            tooltipShow: false,
            isLegendTooltipShow: false,
            isAllDataLoad: false,
            isImperial: true,
            volumeType:"FT³",
            weightType:"LBS",
            orderSummary:{
                "TotVolume":0,
                "TotWeight":0,
                "TotPackages":0,
                "TotPrimaryUnit":0
            },
            inventorySummary: {
                "TotPrimaryAvailable": 0,
                "TotPrimaryAllocated": 0,
                "TotPrimaryOnHold": 0,
                "TotPrimaryOnHand": 0,
                "TotMovableUnits": 0
            },
            isExpandOrderSummary:false,
            isInternalLoading: false
        }


        this.$rootScope = window;
        this.translate = window.translate

    }

    // Native click: React onClick misses after Kendo Window/Menu reparents the DOM.
    // Bind the existing handler directly to the node so it survives reparenting.
    bindNativeClick = (element, handler) => {
        if (!element) {
            return;
        }

        if (element.__wmsBoundHandler === handler && element.__wmsNativeClickHandler) {
            return;
        }

        if (element.__wmsNativeClickHandler) {
            element.removeEventListener("click", element.__wmsNativeClickHandler);
        }

        if (!handler) {
            element.__wmsNativeClickHandler = null;
            element.__wmsBoundHandler = null;
            return;
        }

        const nativeHandler = (event) => {
            handler(event);
        };
        element.__wmsNativeClickHandler = nativeHandler;
        element.__wmsBoundHandler = handler;
        element.addEventListener("click", nativeHandler);
    }

    onExportExcelClick = () => {
        if (!this.props.exportDisable && this.props.eventClickExportGrid) {
            this.props.eventClickExportGrid();
        }
    }

    onExportCsvClick = () => {
        if (!this.props.exportDisable) {
            this.exportGridToCsv();
        }
    }

    componentWillUnmount() {
        if (this._wmsArrowNavListener && this._wmsArrowNavEl) {
            this._wmsArrowNavEl.removeEventListener("keydown", this._wmsArrowNavListener, true);
        }
        this._wmsArrowNavListener = null;
        this._wmsArrowNavEl = null;
    }

    componentDidMount() {
        var that = this;
        // clear grid menu dropdown
        $(this.state.gridDomSelector() + "menu").kendoMenu();

        // prevent columns sorting when resize columns
        var isResizeHandler = false;
        $(this.state.gridDomSelector()).on('mousedown', '.k-grid-header-wrap', (event) => {
            isResizeHandler = $(event.target).hasClass("k-resize-handle");
        });

        $(this.state.gridDomSelector()).on("mouseup", "th.k-table-th span.k-link", function (e) {
            var sortArr = $(that.state.gridDomSelector()).data("kendoGrid").dataSource.sort();
            if (!(e.ctrlKey || e.metaKey) && !isResizeHandler) {
                that.setState({
                    sortArrayGrid: []
                });
                if (sortArr && sortArr.length > 1) {
                    $(that.state.gridDomSelector()).data("kendoGrid").dataSource.sort({});
                }
            }

        });

        // grid column config set
        if (this.props.metaGridConfig != "") {
            var gridOptions = JSON.parse(this.props.metaGridConfig, JSON.dateParser);
            var tempObject = this.props.defaultColumns;
            if (gridOptions.columns) {
                var fieldArray = gridOptions.columns.map(el => el.field);
                var updateColumn = [];
                this.props.allColumns.filter((column) => {
                    if (fieldArray.indexOf(column.field) !== -1) {
                        updateColumn.push(column);
                    } else if (column.locked && column.isShawRowNumberColumnInList != true) {
                        updateColumn.push(column);
                    }
                });
                tempObject = ObjectWms.alignIndexesByPropertyVirtual(gridOptions.columns, updateColumn, "field");
            } else {
                tempObject = ObjectWms.alignIndexesByPropertyVirtual(gridOptions.columns, this.props.defaultColumns, "field")
            }

            this.setState({
                columns: tempObject,
                sorts: gridOptions.sorts,
                filter: (gridOptions.filter) ? gridOptions.filter: [],
                sortArrayGrid: gridOptions.sorts
            }, this.loadGrid);
        } else {
            this.loadGrid();
        }

        $('#' + this.props.wmsSelector + 'scanGridKey').keydown((e) => {
            if (e.keyCode == 13) {
                this.onScanValueEnter();
            }
        });
    }

    onScanValueEnter = () => {
        this.props.OnScanValueEnter(this.state.scanGridKey);
        // call summary function to set select order number in grid top header
        setTimeout(() => {
            this.updateGridSummary();
        }, 300);
    }

    componentWillReceiveProps(nextProps) {
        if (typeof nextProps.staticGridData != "undefined" && nextProps.staticGridData != this.state.staticGridData) {
            var scrollPos = $(this.state.gridDomSelector() + " .k-scrollbar").scrollTop();
            if (typeof $(this.state.gridDomSelector()).data("kendoGrid") != "undefined") {
                $(this.state.gridDomSelector()).data("kendoGrid").dataSource.page(1);
            }
            this.state.dataBindingInitial = 0;
            var mygrid = $(this.state.gridDomSelector()).data("kendoGrid");
            if (typeof mygrid != "undefined") {
                this.eventSelectAll("deselect");
            }
            this.setState({
                staticGridData: nextProps.staticGridData,
                scrollPos: scrollPos,
                isInternalLoading: true
            }, this.readNewDataCall);
        }
        if (nextProps.loading !== this.props.loading) {
            this.updateNoRecordsTemplate(nextProps);
        }
        if(typeof nextProps.isAllDataLoad != "undefined" && nextProps.isAllDataLoad != this.state.isAllDataLoad){
            this.setState({
                isAllDataLoad:nextProps.isAllDataLoad
            })
        }

        // Update columns for inventory combine
        if(this.state.schema != nextProps.schema){
            this.state.dataBindingInitial = 0;
            this.setState({
                columns:nextProps.defaultColumns,
                // dataBindingInitial:0,
                intialiseKeyDown:0,
                schema:nextProps.schema
            }, () => {
                this.loadGridAgain(nextProps);
            })
        }
        // update find order grid summary
        if(this.props.isFindOrderSummary && nextProps.orderSummary != this.props.orderSummary){
            // Set find order grid summary data according radio button from data
            this.setStateOfOrderSummary(nextProps.orderSummary);
        }
        if (this.props.isInventorySummary && nextProps.inventorySummary != this.props.inventorySummary) {
            // Set find order grid summary data according radio button from data
            this.setStateOfInventorySummary(nextProps.inventorySummary);
        }
    }
    setStateOfOrderSummary = (data) =>{
        this.setState({
            orderSummary: {
                "TotVolume": this.state.isImperial ? data.TotVolumeImperial : data.TotVolumeMetric,
                "TotWeight": this.state.isImperial ? data.TotWeightImperial : data.TotWeightMetric,
                "TotPackages": data.TotPackages,
                "TotPrimaryUnit":data.TotPrimaryUnit
            },
            volumeType:this.state.isImperial ? "FT³" : "M³",
            weightType:this.state.isImperial ? "LBS" : "KG",
        })
    }
    setStateOfInventorySummary = (data) => {
        this.setState({
            inventorySummary: data
        })
    }
    loadGridAgain = (nextProps) =>{
        if($(this.state.gridDomSelector()).data('kendoGrid')){
            $(this.state.gridDomSelector()).kendoGrid('destroy').empty();
            if (nextProps.metaGridConfig != "") {
                var gridOptions = JSON.parse(nextProps.metaGridConfig);
                var tempObject = nextProps.defaultColumns;
                if (gridOptions.columns) {
                    var fieldArray = gridOptions.columns.map(el => el.field);
                    var updateColumn = [];
                    nextProps.allColumns.filter((column) => {
                        if (fieldArray.indexOf(column.field) !== -1) {
                            updateColumn.push(column);
                        } else if (column.locked) {
                            updateColumn.push(column);
                        }
                    });
                    tempObject = ObjectWms.alignIndexesByPropertyVirtual(gridOptions.columns, updateColumn, "field");
                } else {
                    tempObject = ObjectWms.alignIndexesByPropertyVirtual(gridOptions.columns,nextProps.defaultColumns, "field")
                }

                this.setState({
                    columns: tempObject,
                    sorts: gridOptions.sorts,
                    filter: (gridOptions.filter) ? gridOptions.filter: [],
                    sortArrayGrid: gridOptions.sorts
                }, () => {
                    this.loadGrid();
                    setTimeout(() => {
                        this.rowNumberUpdate();
                        this.eventSelectAll("deselect");
                    }, 100);
                });
            }else{
                this.loadGrid();
                setTimeout(() => {
                    this.rowNumberUpdate();
                }, 100);
            }

        }

        // $(this.state.gridDomSelector()).data('kendoGrid').refresh();
    }
    readNewDataCall = () => {
        $(this.state.gridDomSelector()).data("kendoGrid").dataSource.read();
        setTimeout(() => {
            $(this.state.gridDomSelector() + " .k-scrollbar").scrollTop(this.state.scrollPos);
            this.updateGridSummary();
            this.filterDataCount();
            this.setState({ isInternalLoading: false });
        }, 200);
    }

    updateNoRecordsTemplate = (nextProps) => {
        // Prevent infinite loop when grid.setOptions triggers dataBound
        if (this.isUpdatingTemplate) {
            return;
        }

        var that = this;
        var props = nextProps || this.props;
        var grid = $(this.state.gridDomSelector()).data("kendoGrid");
        if (!grid || !grid.dataSource) return;

        var noRecordsTemplate = '';
        var templateKey = '';
        if (props.loading) {
            templateKey = 'loading';
            noRecordsTemplate = `<div class="wms-grid-empty-state wms-grid-empty-loading"></div>`;
        } else if(props.emptyRecoredText && props.totalResult === 0) {
            templateKey = 'noMatches';
            noRecordsTemplate = `<div class="wms-grid-empty-state no-matches-found">
                <div class="wms-grid-empty-icon wms-grid-icon-layered">
                    <i class="fa fa-filter wms-filter-shadow"></i>
                    <i class="fa fa-filter wms-filter-main"></i>
                </div>
                <div class="wms-grid-empty-title">No matches found.</div>
                <div class="wms-grid-empty-text">${props.emptyRecoredText}</div>
            </div>`;
        } else if (props.totalResult > props.virtualGridDataLimit && !this.state.isAllDataLoad) {
            templateKey = 'tooManyTransactions';
            noRecordsTemplate = `<div class="wms-grid-empty-state">
                <div class="wms-grid-empty-icon wms-grid-icon-layered">
                    <i class="fa fa-filter wms-filter-shadow"></i>
                    <i class="fa fa-filter wms-filter-main"></i>
                    <i class="fa fa-times-circle wms-filter-cross"></i>
                </div>
                <div class="wms-grid-empty-title">Too many transactions to display.</div>
                <div class="wms-grid-empty-text">Loading all ${props.totalResult ? props.totalResult.toLocaleString() : ''} transactions may take a few minutes.</div>
                <div class="wms-grid-empty-text">Refining your filters can improve performance.</div>
                <div class="wms-grid-empty-text">Would you like to proceed?</div>
                <div class="wms-grid-empty-action">
                    <i class="fa fa-refresh"></i>
                    <span class="wms-grid-empty-link">Load & Wait</span>
                </div>
            </div>`;
        }

        // Only update if template has changed
        if (noRecordsTemplate && this.lastTemplateKey !== templateKey) {
            this.lastTemplateKey = templateKey;
            try {
                this.isUpdatingTemplate = true;
                // Reset intialiseKeyDown so the keydown handler is re-bound after
                // setOptions recreates the grid widget and removes all event listeners
                this.state.intialiseKeyDown = 0;
                grid.setOptions({
                    noRecords: {
                        template: noRecordsTemplate
                    }
                });
                // Reset flag after a small delay to allow grid to complete update
                setTimeout(() => {
                    this.isUpdatingTemplate = false;
                }, 100);
            } catch (e) {
                console.warn('Failed to update noRecords template:', e);
                this.isUpdatingTemplate = false;
            }
        }
    }

    loadGrid = () => {
        var that = this;
        var gridObj = {
            dataSource: {
                pageSize: 40,
                transport: {
                    read: function (e) {
                        e.success(that.state.staticGridData);
                    }
                },
                schema: this.state.schema,
                sort: this.state.sorts,
                filter: this.state.filter  // Let Kendo Grid handle filtering + show in UI
            },
            excel: this.props.exportExcelObj,
            excelExport: (e) =>{
                var sheet = e.workbook.sheets[0];
                var grid = e.sender;
                var fields = grid.dataSource.options.fields;
                var fieldsModels = grid.dataSource.options.schema.model.fields;
                var columns = grid.columns;
                var dateCells = [];

                for (var i = 0; i < fields.length; i++) {
                    var currentField = fields[i].field;
                    var currentModel = fieldsModels[currentField];
                    if (currentModel && currentModel.type === "date") {
                        for (var j = 0; j < columns.length; j++) {
                            if (currentField === columns[j].field) {
                                dateCells.push(j);
                                break;
                            };
                        };
                    };
                };

                var chosenRateCellIndex = -1;
                for (var c = 0; c < columns.length; c++) {
                    if (columns[c].field === "ChosenRate") {
                        chosenRateCellIndex = c;
                        break;
                    }
                }

                for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {
                    var row = sheet.rows[rowIndex];

                    for (var q = 0; q < dateCells.length; q++) {
                        var cellIndex = dateCells[q];
                        var value = row.cells[cellIndex].value;
                        var newValue = kendo.toString(kendo.parseDate(value), 'yyyy-MM-dd HH:mm:ss');
                        row.cells[cellIndex].value = newValue;
                    };
                    if (chosenRateCellIndex >= 0 && row.cells[chosenRateCellIndex]) {
                        var crVal = row.cells[chosenRateCellIndex].value;
                        row.cells[chosenRateCellIndex].value = GlobalService.formatChosenRateForExport(crVal);
                    }
                };
            },
            scrollable: {
                virtual: true
            },
            height: this.props.gridHeight,
            sortable: {
                mode: "multiple",
                allowUnsort: true,
                showIndexes: true
            },
            selectable: this.props.selectable,
            navigatable: true,
            filterable: true,
            inPlaceSort: true,
            batch: this.props.isAddBatchProperty,
            columnMenu: {
                sortable: false,
                columns: false,
                messages: {
                    settings: this.translate('Label_Column_Filter')
                }
            },
            editable: this.props.gridEditable,
            sort: (e) => {
                e.preventDefault();
                GlobalService.sortDataset(that.state.sortArrayGrid, e.sort);
                var grid = $(this.state.gridDomSelector()).data("kendoGrid")
                grid.dataSource.sort(that.state.sortArrayGrid);
                this.props.onSort(e);
                this.rowNumberUpdate();
            },
            dataBound: (e) => {
                that.closeContextMenu();

                var sortArr = [];
                var grid = $(that.state.gridDomSelector()).data("kendoGrid");
                if (grid) {
                    sortArr = $(that.state.gridDomSelector()).data("kendoGrid").dataSource.sort();
                }
                // update sortArrayGrid state when change grid sort outside of grid like from saved filter and sort
                if (sortArr.length && JSON.stringify(that.state.sortArrayGrid) !== JSON.stringify(sortArr)) {
                    that.setState({
                        sortArrayGrid: sortArr
                    });
                }
                this.state.KendoGrid.repaintSelections();
                if (this.state.dataBindingInitial == 0) {
                    setTimeout(() => {
                        this.gridClickEventHandler();
                        this.rowNumberUpdate();
                    }, 10);
                }

                // Update noRecords template dynamically based on data changes
                setTimeout(() => {
                    that.updateNoRecordsTemplate();
                }, 50);

                this.props.onDataBound(e, this.state.KendoGrid);

                if (that.state.intialiseKeyDown == 0) {
                    var grid = $(this.state.gridDomSelector()).data('kendoGrid');
                    grid.wrapper.attr("tabindex", 0);
                    grid.table.on("click", function (e) {
                        // Preserve focus in editors and other interactive controls while
                        // retaining wrapper focus for keyboard row navigation.
                        if ($(e.target).closest(':input, a, button, [contenteditable="true"]').length === 0) {
                            var wrapperEl = grid.wrapper[0];
                            if (wrapperEl && wrapperEl.focus) {
                                wrapperEl.focus({ preventScroll: true });
                            }
                        }
                    });
                    var handleArrowKeySelection = function (e) {
                        if (isEditableKeyboardTarget(e.target)) {
                            return;
                        }
                        // Find Orders is navigatable; Left/Right would cell-select and
                        // rewrite the selected set / qty summary. Match Customers/Roles.
                        if (isHorizontalArrowKey(e)) {
                            if (typeof e.stopImmediatePropagation === "function") {
                                e.stopImmediatePropagation();
                            }
                            e.stopPropagation();
                            e.preventDefault();
                            return;
                        }
                        var direction = arrowKeyDirection(e);
                        if (!direction) {
                            return;
                        }
                        var nativeEvent = e.originalEvent || e;
                        if (nativeEvent._wmsArrowNavHandled) {
                            return;
                        }
                        nativeEvent._wmsArrowNavHandled = true;
                        // Capture on the wrapper so Kendo navigatable Shift+arrow cannot
                        // also extend the range (that made Find Orders skip/jump rows).
                        if (typeof e.stopImmediatePropagation === "function") {
                            e.stopImmediatePropagation();
                        }
                        e.stopPropagation();
                        e.preventDefault();

                        var currentPageRows = grid.dataSource.view();
                        if (!currentPageRows || currentPageRows.length === 0) {
                            return;
                        }
                        var currentPage = grid.dataSource.page();
                        var uniqueKey = that.props.gridKeySelection;
                        var selectedRange = viewIndexRangeForKeys(
                            currentPageRows,
                            uniqueKey,
                            that.state.KendoGrid.getSelections()
                        );
                        var firstSelectedIndex = selectedRange.first;
                        var lastSelectedIndex = selectedRange.last;
                        if (firstSelectedIndex < 0) {
                            grid.select().each(function () {
                                var idx = indexOfViewRow(currentPageRows, grid.dataItem(this));
                                if (idx < 0) {
                                    return;
                                }
                                if (firstSelectedIndex < 0 || idx < firstSelectedIndex) {
                                    firstSelectedIndex = idx;
                                }
                                if (idx > lastSelectedIndex) {
                                    lastSelectedIndex = idx;
                                }
                            });
                        }

                        var lastSelection = that.state.KendoGrid.getLastSelection();
                        var anchorIndex = lastSelection
                            ? indexOfViewRowByKey(currentPageRows, uniqueKey, lastSelection.id)
                            : -1;

                        var activeCell = $(grid.current());
                        if (!activeCell.length) {
                            activeCell = $(e.target).closest("td");
                        }
                        var activeRow = activeCell.closest("tr");
                        var activeRowIndex = activeRow.length ? indexOfViewRow(currentPageRows, grid.dataItem(activeRow)) : -1;

                        var baseRow = resolveArrowBaseRow(direction, !!e.shiftKey, firstSelectedIndex, lastSelectedIndex, anchorIndex, activeRowIndex);
                        var row = getNextArrowNavRow(baseRow, direction, currentPageRows.length);
                        if (row < 0) {
                            return;
                        }

                        var dataItem = currentPageRows[row];
                        var currentNumberOfItems = currentPageRows.length;
                        var col = activeCell.length ? grid.cellIndex(activeCell) : 0;
                        if (col < 0) {
                            col = 0;
                        }

                        if (e.shiftKey && !e.ctrlKey && !e.metaKey) {
                            var rangeFrom = anchorIndex >= 0 ? anchorIndex : firstSelectedIndex;
                            if (rangeFrom < 0) {
                                rangeFrom = activeRowIndex;
                            }
                            if (rangeFrom < 0) {
                                rangeFrom = row;
                            }
                            var selectedData = sliceViewByIndexRange(currentPageRows, rangeFrom, row);
                            if (selectedData.length) {
                                that.state.KendoGrid._uniqueKey = uniqueKey;
                                that.state.KendoGrid.clearSelections();
                                that.state.KendoGrid.addMassToSelection(selectedData);
                            }
                            that.updateGridSummary();
                            that.props.onSelection(that.state.KendoGrid);
                            return;
                        }

                        that.state.KendoGrid.clickEventHandleSelection(e, currentPage, currentNumberOfItems, row, col, dataItem, grid.dataSource.data(), uniqueKey, true, function () {
                            that.updateGridSummary();
                            that.props.onSelection(that.state.KendoGrid);
                        });
                    };
                    if (that._wmsArrowNavListener && that._wmsArrowNavEl) {
                        that._wmsArrowNavEl.removeEventListener("keydown", that._wmsArrowNavListener, true);
                    }
                    grid.table.off("keydown.wmsArrowNav");
                    if (grid.lockedTable) {
                        grid.lockedTable.off("keydown.wmsArrowNav");
                    }
                    grid.wrapper.off("keydown.wmsArrowNav");
                    that._wmsArrowNavListener = handleArrowKeySelection;
                    that._wmsArrowNavEl = grid.wrapper[0];
                    if (that._wmsArrowNavEl) {
                        that._wmsArrowNavEl.addEventListener("keydown", handleArrowKeySelection, true);
                    }
                    that.props.onLockedTableBindKeyEvent();
                    that.state.intialiseKeyDown = 1;
                }
                that.setState({
                    sortColums: GlobalService.getSortedColumnName(that.state.sortArrayGrid, this.props.allColumns),
                });
            },
            // columnMenu: {
            //     messages: {
            //         settings: this.translate('Label_Column_Filter')
            //     }
            // },
            columnShow: (e) => {
                this.props.callForGetNewData();
            },
            filter: (e) => {
                that.state.KendoGrid.clearSelections(function () {
                    that.updateGridSummary();
                    that.state.KendoGrid.repaintSelections();
                });
                that.props.onSelection(that.state.KendoGrid);

                // Update the filter state and reload data
                that.setState({
                    filter: e.filter
                }, function() {
                    // Force reload of data with new filters
                    var grid = $(that.state.gridDomSelector()).data("kendoGrid");
                    if (grid) {
                        grid.dataSource.read();
                    }
                });

                this.props.onGridFilterApplied(e.filter);
                this.filterDataCount();
                setTimeout(() => {
                    this.rowNumberUpdate();
                }, 0);
            },
            columnReorder: (e) => {
                this.props.onColumnReorder(e);
            },
            columnResize: (e) => {
                this.props.onColumnResize(e);
            },
            save: function (data) {
                that.props.onGridSave(data);
            },
            edit: function(data) {
                that.props.onEdit(data);
            },
            resizable: true,
            reorderable: true,
            columns: withVisibleRowNumberHeader(this.state.columns)
        };
        this.updateNoRecordsTemplate();
        $(this.state.gridDomSelector()).kendoGrid(gridObj);

        // Use event delegation to bind click event to "Load & Wait" link
        // This works even when the template is dynamically updated
        $(this.state.gridDomSelector()).off('click', '.wms-grid-empty-link').on('click', '.wms-grid-empty-link', function (e) {
            e.preventDefault();
            if (that.props.loadAllRecords) {
                that.props.loadAllRecords();
            }
        });

        if (this.state.filter && this.state.filter.filters && this.state.filter.filters.length > 0) {
            this.props.onGridFilterApplied(this.state.filter);
        }
    }
    rowNumberUpdate = () => {

        var grid =  $(this.state.gridDomSelector()).data("kendoGrid");
        if(grid) {
            var dataSource = grid.dataSource;
            var data = dataSource.data();
            var sort = dataSource.sort();
            var query = new kendo.data.Query(data);
            var filter = dataSource.filter();
            var sortedData = query.sort(sort).filter(filter).data;
            var index = 0;
            for (var i = 0; i < sortedData.length; i++) {
                //access record using for loop - here i is value from loop
                var firstItem = sortedData[i];
                index ++;
                firstItem["RowNumber"] = index;
            }
            $(this.state.gridDomSelector()).data('kendoGrid').refresh();
        }
    }
    filterDataCount = () => {
        var grid = $(this.state.gridDomSelector()).data("kendoGrid");
        if(grid){
            var dataSource = grid.dataSource;
            setTimeout(() => {
                this.setState({
                    filterResult: dataSource.total()
                });
            }, 100);
        }
    }
    gridClickEventHandler = () => {

        var grid = $(this.state.gridDomSelector()).data('kendoGrid');
        if(grid) {
        grid.table.unbind('click');
        }
        var that = this;
        if(grid) {

        var lockedTableSelector = '';
        if (grid.lockedTable) {
            grid.lockedTable.unbind('click');
            lockedTableSelector = grid.lockedTable;
        }

        $(grid.table).add(lockedTableSelector).on('click', function (e) {
            // Hack: prevent parent grid row selection when click on child grid row
            if ($(e.target).parents('.k-detail-row').length > 0) {
                return;
            }
            // if it is a regular click or shift click we want to deselect everything if selectall is selection, $scope.EventSelectAll checks if this is
            // on or not so calling it doesn't guarantee execution it just checks and does it if it needs it
            // ctrl click we don't want to do it because it can add or deselect
            if (e.ctrlKey || e.metaKey) {
                that.eventSelectAll("deselect", "dontclearselection");
            } else {
                that.eventSelectAll("deselect");
            }
            that.state.KendoGrid.setSelectAllCheckBox(that.state.selectAll);

            var dataItem = grid.dataItem($(e.target).closest('tr'));
            var currentPage = grid.dataSource.page();
            var currentNumberOfItems = grid.dataSource.view().length;
            var row = $(e.target).closest('tr').index();
            var col = grid.cellIndex($(e.target).closest('td'));
            let isVirtualGrid = true;
            that.state.KendoGrid.clickEventHandleSelection(e, currentPage, currentNumberOfItems, row, col, dataItem, grid.dataSource.data(), that.props.gridKeySelection, isVirtualGrid, function () {
                that.updateGridSummary();
                that.props.onSelection(that.state.KendoGrid, "rowClick");
            });
        });
        }


        this.state.dataBindingInitial = 1;
    }


    onChangeFunc(event) {
        var that = this;
        this.setState({
            selectAll: event.target.checked
        });
        setTimeout(function () {
            that.eventSelectAll();
        }, 0);
    }

    onCheckCombine = (event) => {
        this.setState({
            isCombineRows: event.target.checked
        });
        this.props.onCheckCombine(event.target.checked);
    }

    eventSelectAll(pass, dontclearselection) {
        var that = this;
        if (pass == "deselect") {
            if (that.state.selectAll == true) {
                that.setState({ selectAll: false }); // clear select all checkbox
                if (dontclearselection == "dontclearselection") {
                    // we just want to clear the select box above here
                } else {
                    that.state.KendoGrid.clearSelections(function () {
                        that.updateGridSummary();
                        that.state.KendoGrid.repaintSelections();
                    });
                }
            }
        } else {
            if (that.state.selectAll == false) {
                that.state.KendoGrid.clearSelections(function () {
                    that.updateGridSummary();
                    that.state.KendoGrid.repaintSelections();
                });
            } else if (that.state.selectAll == true) {
                if (this.props.inlineSelectAll) {
                    var mygrid = $(this.state.gridDomSelector()).data("kendoGrid");
                    if (typeof mygrid != "undefined") {
                        mygrid.select("tr");
                    }
                } else {
                    that.state.KendoGrid.clearSelections(function () {
                        var dataSource = $(that.state.gridDomSelector()).data("kendoGrid").dataSource;
                        var filteredDataSource = new kendo.data.DataSource({
                            data: dataSource.data(),
                            filter: dataSource.filter(),
                            sort: dataSource.sort()
                        });
                        filteredDataSource.read();
                        var data = filteredDataSource.view();
                        that.state.KendoGrid.addMassToSelection(data);
                        that.updateGridSummary();
                    });
                }
            }
            that.props.onSelection(that.state.KendoGrid);
        }
        if (this.props.inlineSelectAll) {
            this.props.onSelectAllChange();
        }
    }

    updateGridSummary = () => {
        this.setState({ selectedOrders: this.state.KendoGrid.getNumberOfSelections() });
    }


    eventClickColumns = () => {
        // set dataBindingInitial 0 for bind click event on  dataBound:
        this.state.dataBindingInitial = 0;
        this.props.eventClickColumns();
    }

    EventClickResetGrid = () => {
        var that = this;
        this.setState({ isInternalLoading: true });
        this.state.dataBindingInitial = 0;
        this.state.intialiseKeyDown = 0;
        var column = {
            columns: withVisibleRowNumberHeader(this.props.defaultColumns)
        };
        var grid = $(this.state.gridDomSelector()).data("kendoGrid");
        grid.setOptions(column);
        grid.dataSource.sort({});
        this.state.sortColums = '';
        this.state.sortArrayGrid = [];
        this.state.KendoGrid.clearSelections(function () {
            that.state.KendoGrid.repaintSelections();
        });
        this.setState({ isInternalLoading: false });
        this.updateGridSummary();
        this.props.callForGetNewData();
        this.props.onSelection(this.state.KendoGrid);
        this.props.onClickResetGrid();

    }

    onOpenKendoMenu = () => {
        this.closeContextMenu();
    }

    closeContextMenu = () => {
        if (this.refs.VirtualGridWmsContextMenu && this.refs.VirtualGridWmsContextMenu.state.isOpen) {
            this.refs.VirtualGridWmsContextMenu.closeWmsContextMenu();
        }
    }

    EventClickClearFilters = () => {
        var that = this;
        var grid = $(this.state.gridDomSelector()).data("kendoGrid");
        grid.dataSource.filter({});
        this.eventSelectAll("deselect");
        that.state.KendoGrid.clearSelections(function () {
            that.updateGridSummary();
            that.state.KendoGrid.repaintSelections();
            that.props.onSelection(that.state.KendoGrid);
        });

        // Update the filter state and reload data
        that.setState({
            filter: []
        }, function() {
            // Force reload of data with cleared filters
            var grid = $(that.state.gridDomSelector()).data("kendoGrid");
            if (grid) {
                grid.dataSource.read();
            }
        });

        this.props.onGridFilterApplied();
        this.rowNumberUpdate();
    }

    EventClickClearSorts = () => {
        var gridData = $(this.state.gridDomSelector()).data('kendoGrid');
        gridData.dataSource.sort({});
        this.setState({
            sortColums: '',
            sortArrayGrid: []
        });
        this.props.onClickClearSorts();
    }

    eventClickContextMenu = (obj,e) => {
        // prevent click of parent menu in context menu
        if($(e.target).closest('[data-has-child-menu]').attr('data-has-child-menu') == 'true'){
            return true;
        }
        this.props.clickEventOfContextMenu(obj,e);
    }

    eventMouseEnter = (text,baseCall) => {
        if (text == "You cannot auto batch order. Please contact your administrator.") {

        }
        else if (this.state.selectedOrders == 0 && baseCall != 'FromResetGridOptions') {
            return;
        }
        this.setState({
            disabledText: text
        });
    }

    eventMouseLeave = () => {
        this.setState({
            disabledText: ""
        })
    }
    // method for context menu right click
    beforeContextMenuOpen = (e) => {
        if (this.props.isPreventGridRightClick) {
            return;
        }
        //Hack: prevent context menu when click on row detail section
        if ($(e.target).parents('.k-detail-row').length > 0 || $(e.target).hasClass('k-detail-row')) {
            e.preventDefault();
            return;
        }

        var grid = $(this.state.gridDomSelector()).data('kendoGrid');
        var dataItem = grid.dataItem($(e.target).closest('tr'));

        var page = grid.dataSource.page();
        var length = grid.dataSource.view().length;
        var col = grid.cellIndex($(e.target).closest('td'));

        var row2 = $(e.target).closest('tr').index();
        var that = this;
        this.state.KendoGrid.onRightClick(e, page, length, row2, col, dataItem, grid.dataSource.data(), this.props.gridKeySelection, function () {
            that.updateGridSummary();
            that.props.onSelection(that.state.KendoGrid, 'contextMenuClick');
        });

    }
    handleMouseHover = () => {
        this.setState({ isHovering: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovering: false });
    }
    exportGridToCsv = () => {
        var grid =  $(this.state.gridDomSelector()).data("kendoGrid");
        var dataSource = grid.dataSource;
        var data = dataSource.data();
        var sort = dataSource.sort();
        var query = new kendo.data.Query(data);
        var filter = dataSource.filter();
        var sortedData = query.sort(sort).filter(filter).data;
        GlobalService.exportGridtoCSV(sortedData, this.state.gridDomSelector(),this.props.csvExportFileName);
    }

    changeSummaryType = (event) =>{
        // change type
        this.setState({
            isImperial:!this.state.isImperial
        },() =>{
            this.setStateOfOrderSummary(this.props.orderSummary)
        })
    }
    orderSummaryExpand = (param_flag)=> (event) =>{
        var content = $("." + this.props.wmsSelector + "_wms-grid-summery-details");
        content.slideToggle(500, () => {
            this.setState({ isExpandOrderSummary: param_flag });
        });
    }
    handleScanGridKeyChange = (e) => {
       this.setState({ scanGridKey: e.target.value });
    }

    handleScanGridClick = (e) => {
        this.onScanValueEnter();
    }
    setFocusOnScanInput = (e) => {
       this.refs.scanGridKey.focus();
    }
    cleanScanInput = (e) => {
       this.setState({ scanGridKey: '' })
    }


    render() {
        var grid = $(this.state.gridDomSelector()).data('kendoGrid');
        var currentNumberOfItems = 0;
        if(grid){
            currentNumberOfItems = grid.dataSource.view().length;
        }
        return (
            <div className="wms-virtual-grid-holder">
                <div className='table-background-image'/>
                <div className="wms-message-wrapper">
                    {/* {this.props.totalResult > this.props.virtualGridDataLimit && !this.state.isAllDataLoad && !this.props.loadAllMessageFirst &&
                        <span className="error-txt">
                            {this.translate('Label_Grid_Filter_Message').replace(new RegExp('{' + 'dynamicAmount' + '}', 'gi'), this.props.virtualGridDataLimit)}
                            &nbsp;<a className="wms-click-here" onClick={this.props.loadAllRecords}>{this.translate('Label_Grid_Filter_Message_Click_Here')}</a>
                            &nbsp;{this.translate('Label_Grid_Filter_Message_2').replace(new RegExp('{' + 'totalOrders' + '}', 'gi'), this.props.totalResult)}
                        </span>
                    } */}
                    {/* Dynamic message set */}
                    {/* {this.props.totalResult > this.props.virtualGridDataLimit && !this.state.isAllDataLoad && this.props.loadAllMessageFirst &&
                        <span className="error-txt">
                            {this.props.loadAllMessageFirst.replace(new RegExp('{' + 'dynamicAmount' + '}', 'gi'), this.props.virtualGridDataLimit)}
                            &nbsp;<a className="wms-click-here" onClick={this.props.loadAllRecords}>{this.translate('Label_Grid_Filter_Message_Click_Here')}</a>
                            &nbsp;{this.props.loadAllMessageSecond.replace(new RegExp('{' + 'totalOrders' + '}', 'gi'), this.props.totalResult)}
                        </span>
                    } */}
                    {this.props.totalResult > this.props.virtualGridDataLimit && this.state.isAllDataLoad && this.props.isNewColumnAdded &&
                        <span className="error-txt">
                            {this.translate('Label_Grid_Filter_Message_New_Column')}
                            &nbsp;<a className="wms-click-here" onClick={this.props.loadAllRecords}>{this.translate('Label_Grid_Filter_Message_Click_Here')}</a>
                            &nbsp;{this.translate('Label_Grid_Filter_Message_2').replace(new RegExp('{' + 'totalOrders' + '}', 'gi'), this.props.totalResult)}
                        </span>
                    }
                    {this.props.showLoadingError &&
                        <span className="error-txt">{this.translate('Label_Virtual_Grid_Error_Reload')}</span>
                    }
                    {/* {this.props.loading && (
                        <div className="loading-show">Loading... <img src="assets/images/Spinner-1s-35px.gif" /></div>
                    )} */}

                    {this.state.disabledText != '' &&
                        <label className="error-txt">{this.state.disabledText}</label>
                    }

                    {this.props.gifLoaderText != '' &&
                        <div className="wms_alert_msg note loading-text">
                            <img src="assets/images/Spinner-1s-35px.gif" />
                            <span>{this.props.gifLoaderText} in progress</span>
                        </div>
                    }

                </div>
                <div className="wms_area_content">
                    <div className="wms_toolbar">
                        {this.props.shawCheckbox && (
                            <div className="button_list">
                                <div className="checkbox">
                                    <div className="wms_checkbox_wrapper">
                                        <WmsCheckBox
                                            id={this.props.wmsSelector + "virtualGridSelectAll"}
                                            name={this.props.wmsSelector + "virtualGridSelectAll"}
                                            wmsSelector={this.props.wmsSelector + '_SelectAll'}
                                            label={this.translate('Label_Select_All')}
                                            checked={this.state.selectAll}
                                            onChangeFunc={this.onChangeFunc.bind(this)}
                                            isRounded={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.props.shawScanKeyInput && (
                            <div className="scan-key-wrapper">
                                <WmsInput
                                    id={this.props.wmsSelector + 'scanGridKey' }
                                    extraWrapperClass="full-width-input"
                                    inputName={this.props.wmsSelector + 'scanGridKey'}
                                    wmsSelector={this.props.wmsSelector + 'scanGridKey'}
                                    label={''}
                                    value={this.state.scanGridKey}
                                    onChangeFunc={this.handleScanGridKeyChange}
                                    onIconClick={this.handleScanGridClick}
                                    showIconAfterInput={true}
                                    icon={(this.props.scanInputLoading) ? "fa-spinner fa-pulse" : "fa-search"}
                                    isAutoFocus={true}
                                    ref="scanGridKey"
                                    disabled={this.props.disableScanKeyInput}
                                    showToolTip={this.props.shawScanKeyTooltip}
                                    tooltipText={this.props.scanKeyTooltipText}
                                />
                                {this.props.isScanKeyNotAvailable && (
                                    <div className='scan-key-not-found'> { this.translate('Label_Costomer_Record_Not_Found') } </div>
                                )}
                            </div>
                        )}
                        {this.props.showCombineCheckbox && (
                            <div className="button_list">
                                <div className="checkbox">
                                    <div className={"wms_checkbox_wrapper " + (currentNumberOfItems == 0 ? 'wms_checkbox_disabled' : '')}>
                                        <WmsCheckBox
                                            id="virtualGridCombine"
                                            name="virtualGridCombine"
                                            wmsSelector={this.props.wmsSelector + '_CombineRow'}
                                            label={this.translate('Label_Combine_Identical_Rows')}
                                            checked={this.state.isCombineRows}
                                            disabled={currentNumberOfItems == 0}
                                            onChangeFunc={this.onCheckCombine}
                                            isRounded={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <WmsContextMenu
                            ref="VirtualGridWmsContextMenu"
                            eventClickContextMenu={this.eventClickContextMenu}
                            attachTo={this.state.gridDomSelector()}
                            menu={this.props.menu}
                            eventMouseEnter={this.eventMouseEnter}
                            eventMouseLeave={this.eventMouseLeave}
                            onBeforeOpen={(e) => this.beforeContextMenuOpen(e)}
                            contextMenuFilter={this.props.contextMenuFilter} />
                        <div className="wms-toolbar-button ">
                            {this.props.menu.map((obj, index) => {
                                if (typeof obj.isButtonMenu != "undefined" && obj.isButtonMenu != true) {
                                    return "";
                                }
                                if (obj.value.length != 0) {
                                    return (
                                        <WmsButtonDropdown
                                            onOpenKendoMenu={this.onOpenKendoMenu}
                                            windowId={this.props.windowId}
                                            key={index}
                                            wmsSelector={obj.wmsSelector}
                                            id={obj.name.split(' ').join('')}
                                            disabled={obj.disabled}
                                            label={obj.name}
                                            menuIcon={obj.icon}
                                            isHidden={obj.isHidden ? obj.isHidden : false}
                                            buttonType={obj.color}>
                                            <WmsMenuItem
                                                eventMouseEnter={this.eventMouseEnter}
                                                eventMouseLeave={this.eventMouseLeave}
                                                items={obj.value} />
                                        </WmsButtonDropdown>
                                    );
                                }
                                if (obj.isButtonShaw != false) {
                                    return (
                                        <WmsButton
                                            key={index}
                                            wmsSelector={obj.wmsSelector}
                                            disabled={obj.disabled}
                                            icon={obj.icon}
                                            label={obj.name}
                                            buttonType={obj.color}
                                            onClickFunc={obj.clickFunc}
                                            loading={obj.loading}
                                            showToolTip={obj.showToolTip}
                                            tooltipText={obj.tooltipText}
                                            parentClassName={obj.parentClassName ? obj.parentClassName : ''} />
                                    );
                                }
                                return "";
                            })}
                            {this.props.showResetButton == true &&
                                (<div className="reset_btn">
                                    <ul
                                        kendo-menu={this.props.id + "kendoMenu"}
                                        id={this.props.id + "menu"}
                                        k-orientation="'horizontal'"
                                        className="GridMenu"
                                        data-wms-selector={this.props.wmsSelector + '_resetMenu'}
                                    >
                                        <li className="GridMenuTopLink">
                                            <span className="options-title">
                                                <i className="fa fa-sliders" aria-hidden="true"></i>
                                                <span className="virtual-grid-options">Options</span>
                                            </span>
                                            <ul>
                                                <li
                                                    ref={(el) => this.bindNativeClick(el, this.eventClickColumns)}
                                                    data-wms-selector={this.props.wmsSelector + '_columns'}
                                                >
                                                    <span>{this.translate("Label_Columns")}</span>
                                                </li>
                                                <li
                                                    ref={(el) => this.bindNativeClick(el, this.EventClickResetGrid)}
                                                    data-wms-selector={this.props.wmsSelector + '_reset'}
                                                >
                                                    <span>{this.translate("Label_Reset_Grid")}</span>
                                                </li>
                                                {this.props.showColumnFilter && (
                                                    <li
                                                        ref={(el) => this.bindNativeClick(el, this.EventClickClearFilters)}
                                                        data-wms-selector={this.props.wmsSelector + '_clearFilter'}
                                                    >
                                                        <span>{this.translate("Label_Clear_Column_Filters")}</span>
                                                    </li>)
                                                }
                                                {this.props.showSortColumns && (
                                                    <li
                                                        ref={(el) => this.bindNativeClick(el, this.EventClickClearSorts)}
                                                        data-wms-selector={this.props.wmsSelector + '_clearSort'}
                                                    >
                                                        <span>{this.translate("Label_Clear_Sort")}</span>
                                                    </li>)
                                                }
                                                {this.props.exportable ? (
                                                    <li
                                                        ref={(el) => this.bindNativeClick(el, this.onExportExcelClick)}
                                                        onMouseLeave={
                                                            this.props.exportDisable == true ?
                                                                this.eventMouseLeave :
                                                                () => function () { }
                                                        }
                                                        onMouseEnter={
                                                            this.props.exportDisable == true ?
                                                                () => this.eventMouseEnter(this.props.exportGridDisabledText,'FromResetGridOptions') :
                                                                () => function () { }
                                                        }
                                                        test="Helloooo"
                                                        data-wms-selector={this.props.wmsSelector + '_exportExcelGrid'}
                                                        className={(this.props.exportDisable ? 'wms-disabled-look' : 'k-state-default') + ' k-item ExportGrid'}
                                                    >
                                                        <span>{this.translate("Label_Export_Excel_Grid")}</span>
                                                    </li>
                                                ) : null}
                                                {this.props.exportable ? (
                                                    <li
                                                        ref={(el) => this.bindNativeClick(el, this.onExportCsvClick)}
                                                        onMouseLeave={
                                                            this.props.exportDisable == true ?
                                                                this.eventMouseLeave :
                                                                () => function () { }
                                                        }
                                                        onMouseEnter={
                                                            this.props.exportDisable == true ?
                                                                () => this.eventMouseEnter(this.props.exportGridDisabledText,'FromResetGridOptions') :
                                                                () => function () { }
                                                        }
                                                        test="Helloooo"
                                                        data-wms-selector={this.props.wmsSelector + '_exportCsvGrid'}
                                                        className={(this.props.exportDisable ? 'wms-disabled-look' : 'k-state-default') + ' k-item ExportGrid'}
                                                    >
                                                    <span>{this.translate("Label_Export_CSV_Grid")}</span>
                                                </li>
                                            ) : null}
                                            {this.props.customOptionsMenuItems && this.props.customOptionsMenuItems.length > 0 &&
                                                this.props.customOptionsMenuItems.map((menuItem, index) => (
                                                    <li
                                                        key={index}
                                                        ref={(el) => this.bindNativeClick(el, menuItem.onClick)}
                                                        data-wms-selector={menuItem.wmsSelector}
                                                        className={menuItem.className || 'k-state-default k-item'}
                                                    >
                                                        <span>{menuItem.label}</span>
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                        </li>
                                    </ul>
                                </div>)
                            }
                        </div>
                    </div>
                    {this.props.showContentBetweenGridAndOptions && (
                        <div className="wms-content-between-grid-and-options">
                            <label>{this.props.contentLabel}</label>
                            <span>{this.props.contentValue}</span>
                        </div>
                    )}
                    <div className="wms-grid-details">
                        {this.props.showGridResult == true &&
                            <label className="wms_grid_results">
                                <span>{this.props.totalResult}</span>{this.translate("Label_Results")}
                            </label>
                        }

                        {this.props.showGridSummary &&
                            <label className="wms_grid_selected">
                                <span>{this.state.selectedOrders}</span>{this.translate("Label_Grid_Selected")}
                            </label>
                        }

                        {this.state.sortColums != "" && this.props.showSortColumns && (
                            <label className="sort"> Sort: <span className="no-space">{this.state.sortColums}</span> </label>
                        )}

                        {this.props.filterText != '' && (
                            <span className="wms-filter-text"  >
                                <span>{this.state.filterResult} Results With </span>
                                <span>{this.props.filterText}</span>
                                <div className="wms-filter-tooltip">
                                    <i className="fa fa-info-circle show_more"
                                        onMouseOver={() => this.setState({ tooltipShow: true })}
                                        onMouseOut={() => this.setState({ tooltipShow: false })}
                                    ></i>
                                    {this.state.tooltipShow && (
                                        <div className="wms-filter-tooltip-content">
                                            <span dangerouslySetInnerHTML={{ __html: this.props.fullFilterText }} />
                                        </div>
                                    )}
                                </div>
                            </span>
                        )}
                        <div className="grid-right-content">
                        {this.props.summaryMenuIcon && (
                            <button
                                type="button"
                                className="wms-grid-summary-menu"
                                ref={(el) => this.bindNativeClick(el, this.props.onSummaryMenuClick)}
                                data-wms-selector={this.props.wmsSelector + "_summaryMenu"}
                                aria-label={this.translate("Label_Columns")}
                            >
                                {this.props.summaryMenuIcon === "ellipsis" ? (
                                    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true">
                                        <circle cx="8" cy="3.2" r="1.35" />
                                        <circle cx="8" cy="8" r="1.35" />
                                        <circle cx="8" cy="12.8" r="1.35" />
                                    </svg>
                                ) : (
                                    <i className={"fa " + this.props.summaryMenuIcon} aria-hidden="true"></i>
                                )}
                            </button>
                        )}
                        {this.props.isLegendSet && (
                            <div className="wms-legend-tooltip wms-filter-tooltip">
                                <i className="fa fa-info-circle show_more"
                                    onMouseOver={() => this.setState({ isLegendTooltipShow: true })}
                                    onMouseOut={() => this.setState({ isLegendTooltipShow: false })}
                                ></i>
                                {this.state.isLegendTooltipShow && (
                                    <div className="wms-filter-tooltip-content">
                                        <ul>
                                            <li><span className="wms-color-box1"></span><span>No Line Items</span></li>
                                            <li><span className="wms-color-box2"></span><span>Unallocated</span></li>
                                            <li><span className="wms-color-box3"></span><span>Partially Allocated</span></li>
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )}
                        {(this.props.isFindOrderSummary || this.props.isInventorySummary) && (
                            <div className="wms-filter-tooltip">
                                {this.state.isExpandOrderSummary == false ? (
                                    <i className="fa fa-chevron-down"
                                    onClick={this.orderSummaryExpand(true)}
                                    ></i>
                                ):(
                                    <i className="fa fa-chevron-up"
                                    onClick={this.orderSummaryExpand(false)}
                                    ></i>
                                )}
                            </div>
                        )}
                        </div>
                    </div>
                    {this.props.isFindOrderSummary && (
                        <div className={this.props.wmsSelector + "_wms-grid-summery-details wms-findorder-grid-details"} style={{ display: this.state.isExpandOrderSummary ? 'flex' : 'none' }}>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.orderSummary.TotVolume ? this.state.orderSummary.TotVolume.toFixed(4) : "0.0000"}</p>
                                <p className="details-name">Total Volume ({this.state.volumeType})</p>
                            </div>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.orderSummary.TotWeight ? this.state.orderSummary.TotWeight.toFixed(4) : "0.0000"}</p>
                                <p className="details-name">Total Weight ({this.state.weightType})</p>
                            </div>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.orderSummary.TotPackages}</p>
                                <p className="details-name">Total Packages</p>
                            </div>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.orderSummary.TotPrimaryUnit}</p>
                                <p className="details-name">Total Primary Units</p>
                            </div>
                            <div className="wms-details-radio-section">
                                <WmsRadio
                                    id="IsImperial"
                                    name="IsImperial"
                                    label={this.translate('Label_US_Imperial')}
                                    wmsSelector={this.props.wmsSelector + 'IsImperial'}
                                    onChangeFunc={this.changeSummaryType}
                                    value={this.state.isImperial}
                                    checked={this.state.isImperial == true}
                                />

                                <WmsRadio
                                    id="metric"
                                    name="IsImperial"
                                    label={this.translate('Label_Metric')}
                                    wmsSelector={this.props.wmsSelector + 'Metric'}
                                    onChangeFunc={this.changeSummaryType}
                                    value={this.state.isImperial}
                                    checked={this.state.isImperial != true}
                                />
                            </div>
                        </div>
                    )}
                    {this.props.inventorySummary && (
                        <div className={this.props.wmsSelector + "_wms-grid-summery-details wms-findorder-grid-details"} style={{ display: this.state.isExpandOrderSummary ? 'flex' : 'none' }}>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.inventorySummary.TotPrimaryAvailable ? this.state.inventorySummary.TotPrimaryAvailable.toFixed(2) : "0"}</p>
                                <p className="details-name">Primary Available</p>
                            </div>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.inventorySummary.TotPrimaryAllocated ? this.state.inventorySummary.TotPrimaryAllocated.toFixed(2) : "0"}</p>
                                <p className="details-name">Primary Allocated</p>
                            </div>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.inventorySummary.TotPrimaryOnHold ? this.state.inventorySummary.TotPrimaryOnHold.toFixed(2) : "0"}</p>
                                <p className="details-name">Primary On Hold</p>
                            </div>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.inventorySummary.TotPrimaryOnHand ? this.state.inventorySummary.TotPrimaryOnHand.toFixed(2) : "0"}</p>
                                <p className="details-name">Primary On Hand</p>
                            </div>
                            <div className="wms-details-data-section">
                                <p className="details-count">{this.state.inventorySummary.TotMovableUnits ? this.state.inventorySummary.TotMovableUnits : "0"}</p>
                                <p className="details-name">Movable Units</p>
                            </div>

                        </div>
                    )}
                </div>

                <div className="wms-grid-area-wrapper">
                    <div className="wms_area_border">
                        <div id="gridContainer" className="gridContainer">
                            {(this.props.loading || this.state.isInternalLoading) && (
                                <div className="wms-grid-loading-overlay">
                                    <div className="wms-grid-loading-content">
                                        <div className="wms-grid-loading-spinner">
                                            <i className="fa fa-spinner fa-spin"></i>
                                        </div>
                                        <div className="wms-grid-loading-text">Loading new data...</div>
                                    </div>
                                </div>
                            )}
                            <div
                                className="no-josh"
                                id={this.props.id}
                                data-wms-selector={this.props.wmsSelector}
                            />
                        </div>
                    </div>
                </div>
            </div >
        );
    }
};
VirtualGridComponent.propTypes = {
    defaultColumns: PropTypes.array.isRequired,
    allColumns: PropTypes.array.isRequired,
    config: PropTypes.object,
    staticGridData: PropTypes.array,
    exportable: PropTypes.bool,
    exportDisable: PropTypes.bool,
    exportGridDisabledText: PropTypes.string,
    eventClickExportGrid: PropTypes.func, // this should control export of grid
    gridName: PropTypes.string.isRequired,
    virtual: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired, // this should write the id to the input
    wmsSelector: PropTypes.string.isRequired, // this should set up a selector on the input
    languageHeaders: PropTypes.array,
    windowId: PropTypes.string,
    shawCheckbox: PropTypes.bool,
    showCombineCheckbox: PropTypes.bool,
    shawScanKeyInput: PropTypes.bool,
    shawScanKeyTooltip: PropTypes.bool,
    scanKeyTooltipText: PropTypes.string,
    disableScanKeyInput: PropTypes.bool,
    scanInputLoading: PropTypes.bool,
    OnScanValueEnter: PropTypes.func,
    isScanKeyNotAvailable: PropTypes.bool,
    onSelection: PropTypes.func.isRequired, // this should control the selection of row event
    isPreventGridRightClick: PropTypes.bool, // this should control the right click event of grid
    clickEventOfContextMenu: PropTypes.func, // this should control the selection of row event
    filterObject: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]), // Object for filter grid
    getGridSelectionUrl: PropTypes.string, // url of get selection list of records
    inlineFilter: PropTypes.bool, // this should control inline filter of grid or call api,
    inlineSelectAll: PropTypes.bool, // this should control inline all record selection of grid or call api,
    onSelectAllChange: PropTypes.func, // this function call when selectall chane for inline selection,
    searchUrl: PropTypes.string,
    gridEditable: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.object
    ]), // set true or multiple edit column object to make grid columns editable
    showSortColumns: PropTypes.bool, // set true to shaw sotable columns in grid
    showColumnFilter: PropTypes.bool, // set true to shaw clear column filter in grid
    gridHeight: PropTypes.string, // number for set grid height in px
    onLoadGrid: PropTypes.func,
    onDataBound: PropTypes.func,
    onGridFilterApplied: PropTypes.func,
    loadAllRecords: PropTypes.func,
    callForGetNewData: PropTypes.func,
    eventClickColumns: PropTypes.func,
    onEdit: PropTypes.func,// this function call when grid column's edit
    onSort: PropTypes.func,// this function call when grid column's sort
    onColumnReorder: PropTypes.func,// this function call when grid column's order change
    onColumnResize: PropTypes.func,// this function call when grid column's size change
    onClickClearSorts: PropTypes.func,// this function call when click on clear sort button
    onClickResetGrid: PropTypes.func,// this function call when click on reset default grid layout menu
    onCheckCombine: PropTypes.func,// this function call when Check combine row checkbox
    virtualGridpageSize: PropTypes.number,// set page size in virtual grid read api call
    isColumnFilterenable: PropTypes.bool, // set false to hide column filter option from in grid menu
    isColumnShowenable: PropTypes.bool, // set false to hide column display option from in grid menu
    exportExcelObj: PropTypes.object, // set export excel config
    metaGridConfig: PropTypes.string, // grid config meta data
    isAddBatchProperty: PropTypes.bool, // set true to add Batch property in grid data source obj
    selectable: PropTypes.string, // set default multiple to selectable multiple row
    isAlignIndexesByProperty: PropTypes.bool, // set true to  execute AlignIndexesByProperty() on default columns layout set
    metaDataFieldsName: PropTypes.string.isRequired, // it's use for save column data in meta data
    isNewColumnAdded: PropTypes.bool, // it's use for save column data in meta data
    isLegendSet: PropTypes.bool, // show legend for order allocation status
    isFindOrderSummary: PropTypes.bool, // show summary for find order
    summaryMenuIcon: PropTypes.string, // font-awesome icon on the selected bar, in place of the summary caret
    onSummaryMenuClick: PropTypes.func,
    isInventorySummary: PropTypes.bool, // show summary for inventory
    csvExportFileName: PropTypes.string, // it's use for save column data in meta data
    contentLabel: PropTypes.string, // show content above grid and options
    contentValue: PropTypes.string, // show content above grid and options
    virtualGridDataLimit: PropTypes.number, // set virtualGrigData limit default value is define in global service,
    showLoadingError: PropTypes.bool,
    customOptionsMenuItems: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        wmsSelector: PropTypes.string,
        className: PropTypes.string
    })) // array of custom menu items to add to the options menu

}

VirtualGridComponent.defaultProps = {
    exportable: false,
    exportDisable: false,
    exportGridDisabledText: '',
    shawCheckbox: true,
    showCombineCheckbox: false,
    shawScanKeyInput: false,
    shawScanKeyTooltip: false,
    scanKeyTooltipText: '',
    disableScanKeyInput: false,
    isScanKeyNotAvailable: false,
    scanInputLoading: false,
    OnScanValueEnter: (e) => function () { },
    inlineFilter: false,
    inlineSelectAll: false,
    gridEditable: false,
    showResetButton: true,
    showGridResult: true,
    gifLoaderText: '',
    showSortColumns: true,
    showColumnFilter: true,
    isPreventGridRightClick: false,
    gridHeight: '99%',
    onLoadGrid: (e) => function () { },
    onGridBinding: (e) => function () { },
    onGridChange: (e) => function () { },
    onGridSave: (e) => function () { },
    onDataBound: (e) => function () { },
    onEdit: (e) => function () { },
    onSort: (e) => function () { },
    onColumnReorder: (e) => function () { },
    onColumnResize: (e) => function () { },
    onClickClearSorts: (e) => function () { },
    onClickResetGrid: (e) => function () { },
    onSelectAllChange: (e) => function () { },
    onGridFilterApplied: (e) => function () { },
    loadAllRecords: (e) => function () { },
    callForGetNewData: (e) => function () { },
    eventClickColumns: (e) => function () { },
    onCheckCombine: (e) => function () { },
    onLockedTableBindKeyEvent: (e) => function () { },
    virtualGridpageSize: 50,
    isColumnFilterenable: true,
    isColumnShowenable: true,
    exportExcelObj: {},
    metaGridConfig: "",
    isAlignIndexesByProperty: false,
    isAddBatchProperty: false,
    selectable: "multiple",
    isNewColumnAdded:false,
    isLegendSet:false,
    isFindOrderSummary:false,
    summaryMenuIcon: "",
    onSummaryMenuClick: (e) => function () { },
    isInventorySummary:false,
    contentLabel:'',
    contentValue:'',
    csvExportFileName:'orderGridExport',
    virtualGridDataLimit:GlobalService.constants.virtualGridDataLimit,
    emptyRecoredText: "",
    showLoadingError: false
}

export default VirtualGridComponent;
